import { CaretUpOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Namespace } from '@data/utils/enums';
import { Button, AntdCheckbox, AntdTypography } from '@ui/components';
import { FilterOption as FilterOptionType } from '../../../../../../types';
import './styles.css';

const { Text } = AntdTypography;

type FilterOptionProps = {
  isChecked: boolean;
  isDynamic: boolean;
  isNestedFiltersOpen: boolean;
  onChange: (value: string, label?: string) => void;
  option: FilterOptionType;
  toggleNestedFiltersOpen: () => void;
};

export const FilterOption = ({
  option: { label, value, isLeaf, children },
  isDynamic,
  onChange,
  isChecked,
  toggleNestedFiltersOpen,
  isNestedFiltersOpen,
}: FilterOptionProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const showNestedOptions = typeof isLeaf === 'boolean' && !isLeaf && !!children?.length;

  return (
    <li className={cx('mb-1 ml-1 flex', isLeaf && 'ml-6')}>
      {showNestedOptions && (
        <Button onClick={toggleNestedFiltersOpen} type="text" size="small">
          <CaretUpOutlined
            className={cx(
              'duration-300 px-0 text-base-600',
              isNestedFiltersOpen ? 'rotate-0' : 'rotate-180',
            )}
          />
        </Button>
      )}
      <AntdCheckbox
        checked={isChecked}
        onChange={() => onChange(value, isDynamic ? label : undefined)}
        className={cx('large-checkbox w-full checkbox', !showNestedOptions && 'ml-4')}
      >
        <Text className="text-base">{isDynamic ? label : t(label)}</Text>
      </AntdCheckbox>
    </li>
  );
};
